// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r5-5";
export var filledCircle = "_r5-4";
export var historyEntry = "_r5-3";
export var messageSideLeft = "_r5-1";
export var messageSideRight = "_r5-2";
export var orderTrackingCarouselWrapper = "_r5-6";
export var orderTrackingInfoContainer = "_r5-0";